import { render, staticRenderFns } from "./ModalLabaRugi.vue?vue&type=template&id=93f1f5dc"
import script from "./ModalLabaRugi.vue?vue&type=script&lang=js"
export * from "./ModalLabaRugi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports